export default function resizeImage(url, width = 50, height = null) {
  return `https://my.tory.ae/resize?href=${url}&w=${width}&h=${height}`;
}
